import './DIContainer'
import Vue from 'vue'
import './design/element-variables.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import CorePlugins from '@core/CorePlugins'
import { container } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import UUID from './util/UUID'
import axios from 'axios'
const $uuid = new UUID()

Vue.prototype.$uuid = $uuid
Vue.prototype.$baseURL = __BASE_URL__

CorePlugins.forEach(({ plugin, options }) => {
  if (options) {
    Vue.use(plugin, options)
  } else {
    Vue.use(plugin)
  }
})

Vue.config.productionTip = false

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

axios.interceptors.response.use((response) => {
  // if missing user login, redirect to login page
  // Note: for user unauthenticated, backend should return status code 401 instate of 200
  // without frontend to check the error message, due to error message sometimes can be misspell
  if (response?.data?.error === 'Missing User Login') {
    if (vue.$route.name !== 'Login') {
      vue.$router.push({ name: 'Login', query: { redirect: vue.$route.fullPath } })
    }
  }
  return Promise.resolve(response)
})

const shareVariable = container.get<SharedVariable>('SharedVariable')
shareVariable.vue = vue
